import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'point', 'Point', [["path",{"d":"M8 12a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"}]]);